export const REQUEST_BASE_URL = "https://dbpedia.org/sparql";
export const RESOURCE_BASE_URL = "http://dbpedia.org/resource/";
